// extracted by mini-css-extract-plugin
export default {"form":"SignUp_form__w5YT4","subform":"SignUp_subform__FZp8W","btn__container":"SignUp_btn__container__xhxaL","finish__form":"SignUp_finish__form__v2etA"};